module.exports = __webpack_public_path__ + "img/meeting.d159fe0c.svg";